import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-12 w-full min-w-0 rounded-md border-4 border-black dark:border-white bg-white dark:bg-gray-900 px-4 py-3 text-base font-bold text-black dark:text-white placeholder:text-black/60 dark:placeholder:text-white/60 transition-all duration-200 outline-none",
        "focus:bg-[#facc15] focus:border-8 focus:border-black dark:focus:border-white",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-bold file:text-black dark:file:text-white",
        className
      )}
      {...props}
    />
  )
}

export { Input }
